var map = {
	"./animations/checkmark": "8ff5",
	"./animations/checkmark.json": "8ff5",
	"./animations/congratulations": "8b37",
	"./animations/congratulations.json": "8b37",
	"./animations/congratulationsMD": "d4ac",
	"./animations/congratulationsMD.json": "d4ac",
	"./animations/congratulationsMD2": "2ed7",
	"./animations/congratulationsMD2.json": "2ed7",
	"./groups/cash.png": "3b3a",
	"./groups/cash_nl10.png": "a523",
	"./groups/cash_nl100.png": "8a21",
	"./groups/cash_nl1000-2000.png": "23e4",
	"./groups/cash_nl1000.png": "950b",
	"./groups/cash_nl2.png": "0411",
	"./groups/cash_nl200.png": "0c58",
	"./groups/cash_nl25.png": "adbc",
	"./groups/cash_nl5.png": "7b40",
	"./groups/cash_nl50.png": "3a57",
	"./groups/cash_nl500-1000.png": "5ad5",
	"./groups/cash_nl500.png": "04bc",
	"./groups/external.png": "992b",
	"./groups/img-1.png": "9d4f",
	"./groups/mtt_1.png": "f9d5",
	"./groups/mtt_2.png": "5935",
	"./groups/mtt_3.png": "0eeb",
	"./groups/mtt_4.png": "f736",
	"./groups/mtt_5.png": "0d53",
	"./groups/mtt_6.png": "8522",
	"./groups/mtt_7.png": "9757",
	"./groups/nogroup.png": "f4b8",
	"./groups/spins_1.png": "bc60",
	"./groups/spins_10.png": "1d52",
	"./groups/spins_11.png": "bb17",
	"./groups/spins_2.png": "ef91",
	"./groups/spins_3.png": "dbe3",
	"./groups/spins_4.png": "df29",
	"./groups/spins_5.png": "0c1f",
	"./groups/spins_6.png": "706e",
	"./groups/spins_7.png": "df98",
	"./groups/spins_8.png": "0d04",
	"./groups/spins_9.png": "4c59",
	"./groups_badges/cash.png": "0c33",
	"./groups_badges/cash_nl10.png": "796f",
	"./groups_badges/cash_nl100.png": "a2ad",
	"./groups_badges/cash_nl1000-2000.png": "a9af",
	"./groups_badges/cash_nl1000.png": "f8af",
	"./groups_badges/cash_nl2.png": "6123",
	"./groups_badges/cash_nl200.png": "f151",
	"./groups_badges/cash_nl25.png": "9146",
	"./groups_badges/cash_nl5.png": "57e3",
	"./groups_badges/cash_nl50.png": "6de0",
	"./groups_badges/cash_nl500-1000.png": "0f34",
	"./groups_badges/cash_nl500.png": "c3c1",
	"./groups_badges/confetti_dialog.png": "01f5",
	"./groups_badges/default.png": "3736",
	"./groups_badges/external.png": "7b3a",
	"./groups_badges/img-badge.png": "f331",
	"./groups_badges/mtt.png": "964a",
	"./groups_badges/mtt_1.1.png": "4098",
	"./groups_badges/mtt_1.2.png": "811d",
	"./groups_badges/mtt_1.3.png": "0f25",
	"./groups_badges/mtt_1.4.png": "9553",
	"./groups_badges/mtt_1.5.png": "7145",
	"./groups_badges/mtt_2.1.png": "98d8",
	"./groups_badges/mtt_2.2.png": "90434",
	"./groups_badges/mtt_2.3.png": "3a3e",
	"./groups_badges/mtt_2.4.png": "a13d",
	"./groups_badges/mtt_3.1.png": "4826",
	"./groups_badges/mtt_3.2.png": "7fe6",
	"./groups_badges/mtt_3.3.png": "5464",
	"./groups_badges/mtt_3.4.png": "bb2a",
	"./groups_badges/mtt_4.1.png": "c87c",
	"./groups_badges/mtt_4.2.png": "31ac",
	"./groups_badges/mtt_4.5.png": "c28d",
	"./groups_badges/mtt_4.8.png": "92dc",
	"./groups_badges/mtt_5.1.png": "8fbd",
	"./groups_badges/mtt_5.5.png": "3b16",
	"./groups_badges/mtt_6.1.png": "319b",
	"./groups_badges/mtt_6.5.png": "7213",
	"./groups_badges/mtt_7.1.png": "3f0b",
	"./groups_badges/mtt_7.5.png": "5781",
	"./groups_badges/spins.png": "4cb9",
	"./groups_badges/spins_1.5.png": "96d1",
	"./groups_badges/spins_1.png": "9c05",
	"./groups_badges/spins_10.png": "62f7",
	"./groups_badges/spins_11.png": "835b",
	"./groups_badges/spins_2.png": "e2a3",
	"./groups_badges/spins_3.5.png": "ceaf",
	"./groups_badges/spins_3.png": "48b3",
	"./groups_badges/spins_4.png": "522c",
	"./groups_badges/spins_5.png": "24c5",
	"./groups_badges/spins_6.5.png": "0c31",
	"./groups_badges/spins_6.png": "c9c7",
	"./groups_badges/spins_7.png": "7156",
	"./groups_badges/spins_8.png": "16b3",
	"./groups_badges/spins_9.png": "7656",
	"./icons/Cards_Hand.svg": "69bd",
	"./icons/Trophy.svg": "74a9",
	"./icons/check.png": "e209",
	"./icons/cross.png": "c087",
	"./icons/done.svg": "e404",
	"./icons/greycircle.png": "2779",
	"./images/bg-pattern-polarize.png": "a747",
	"./images/countries/ABW.svg": "a467",
	"./images/countries/AFG.svg": "c937",
	"./images/countries/AGO.svg": "06d8",
	"./images/countries/AIA.svg": "3e47",
	"./images/countries/ALA.svg": "c2c6",
	"./images/countries/ALB.svg": "f1b4",
	"./images/countries/AND.svg": "c4ee",
	"./images/countries/ANT.svg": "c810",
	"./images/countries/ARE.svg": "09db",
	"./images/countries/ARG.svg": "fb41",
	"./images/countries/ARM.svg": "fcc1",
	"./images/countries/ASM.svg": "2aa3",
	"./images/countries/ATA.svg": "a6be",
	"./images/countries/ATF.svg": "7ea0",
	"./images/countries/ATG.svg": "b0ab",
	"./images/countries/AUS.svg": "095f",
	"./images/countries/AUT.svg": "d004",
	"./images/countries/AZE.svg": "196c",
	"./images/countries/BDI.svg": "a174",
	"./images/countries/BEL.svg": "e18f",
	"./images/countries/BEN.svg": "f874",
	"./images/countries/BES.svg": "7dfd",
	"./images/countries/BFA.svg": "9f6d",
	"./images/countries/BGD.svg": "54c9",
	"./images/countries/BGR.svg": "e802",
	"./images/countries/BHR.svg": "3250",
	"./images/countries/BHS.svg": "9081",
	"./images/countries/BIH.svg": "1a70",
	"./images/countries/BLM.svg": "3a68",
	"./images/countries/BLR.svg": "eeb0",
	"./images/countries/BLZ.svg": "4099",
	"./images/countries/BMU.svg": "0705",
	"./images/countries/BOL.svg": "4ee9",
	"./images/countries/BRA.svg": "baff",
	"./images/countries/BRB.svg": "46ee",
	"./images/countries/BRN.svg": "9845",
	"./images/countries/BTN.svg": "bbe5",
	"./images/countries/BVT.svg": "bcd7",
	"./images/countries/BWA.svg": "0c50",
	"./images/countries/CAF.svg": "25fb",
	"./images/countries/CAN.svg": "1fe1",
	"./images/countries/CCK.svg": "db6e",
	"./images/countries/CHE.svg": "4ad9",
	"./images/countries/CHL.svg": "706c",
	"./images/countries/CHN.svg": "1e49",
	"./images/countries/CIV.svg": "deec",
	"./images/countries/CMR.svg": "f2e9",
	"./images/countries/COD.svg": "9231",
	"./images/countries/COG.svg": "fcbb",
	"./images/countries/COK.svg": "2fb1",
	"./images/countries/COL.svg": "209f",
	"./images/countries/COM.svg": "4517",
	"./images/countries/CPV.svg": "174d",
	"./images/countries/CRI.svg": "1081",
	"./images/countries/CUB.svg": "1781",
	"./images/countries/CUW.svg": "865b",
	"./images/countries/CXR.svg": "6f7e",
	"./images/countries/CYM.svg": "cc9e",
	"./images/countries/CYP.svg": "f970",
	"./images/countries/CZE.svg": "7c2f",
	"./images/countries/DEU.svg": "d5c7",
	"./images/countries/DJI.svg": "c0f4",
	"./images/countries/DMA.svg": "6f89",
	"./images/countries/DNK.svg": "3d0a",
	"./images/countries/DOM.svg": "4739",
	"./images/countries/DZA.svg": "67cd",
	"./images/countries/ECU.svg": "7adc",
	"./images/countries/EGY.svg": "632a",
	"./images/countries/ERI.svg": "88f8",
	"./images/countries/ESH.svg": "f321",
	"./images/countries/ESP.svg": "2381",
	"./images/countries/EST.svg": "2c16",
	"./images/countries/ETH.svg": "0cc1",
	"./images/countries/FIN.svg": "cba5",
	"./images/countries/FJI.svg": "df53",
	"./images/countries/FLK.svg": "6a09",
	"./images/countries/FRA.svg": "600f",
	"./images/countries/FRO.svg": "e87d",
	"./images/countries/FSM.svg": "3a4b",
	"./images/countries/GAB.svg": "a907",
	"./images/countries/GBR.svg": "7fc4",
	"./images/countries/GEO.svg": "282b",
	"./images/countries/GGY.svg": "e2ab",
	"./images/countries/GHA.svg": "7076",
	"./images/countries/GIB.svg": "20a2",
	"./images/countries/GIN.svg": "c301",
	"./images/countries/GLP.svg": "3aa3",
	"./images/countries/GMB.svg": "4334",
	"./images/countries/GNB.svg": "36a9",
	"./images/countries/GNQ.svg": "05bf",
	"./images/countries/GRC.svg": "9257",
	"./images/countries/GRD.svg": "4314",
	"./images/countries/GRL.svg": "9ffa",
	"./images/countries/GTM.svg": "141a",
	"./images/countries/GUF.svg": "1392",
	"./images/countries/GUM.svg": "f09d",
	"./images/countries/GUY.svg": "ff95",
	"./images/countries/HKG.svg": "470b",
	"./images/countries/HMD.svg": "ec97",
	"./images/countries/HND.svg": "f31c",
	"./images/countries/HRV.svg": "ba7d",
	"./images/countries/HTI.svg": "89fb",
	"./images/countries/HUN.svg": "3f2b",
	"./images/countries/IDN.svg": "e155",
	"./images/countries/IMN.svg": "ee3a",
	"./images/countries/IND.svg": "a7d4",
	"./images/countries/IOT.svg": "c93f",
	"./images/countries/IRL.svg": "852a",
	"./images/countries/IRN.svg": "a13b",
	"./images/countries/IRQ.svg": "5395",
	"./images/countries/ISL.svg": "55af",
	"./images/countries/ISR.svg": "40bd",
	"./images/countries/ITA.svg": "9d97",
	"./images/countries/JAM.svg": "fc72",
	"./images/countries/JEY.svg": "c1aa",
	"./images/countries/JOR.svg": "9a2a",
	"./images/countries/JPN.svg": "ad24",
	"./images/countries/KAZ.svg": "6435",
	"./images/countries/KEN.svg": "69e1",
	"./images/countries/KGZ.svg": "55a8",
	"./images/countries/KHM.svg": "c846",
	"./images/countries/KIR.svg": "959f",
	"./images/countries/KNA.svg": "2aae",
	"./images/countries/KOR.svg": "1b07",
	"./images/countries/KWT.svg": "4152",
	"./images/countries/LAO.svg": "0681",
	"./images/countries/LBN.svg": "de50",
	"./images/countries/LBR.svg": "c079",
	"./images/countries/LBY.svg": "b54f",
	"./images/countries/LCA.svg": "29c1",
	"./images/countries/LIE.svg": "3366",
	"./images/countries/LKA.svg": "8663",
	"./images/countries/LSO.svg": "9fc5",
	"./images/countries/LTU.svg": "326e",
	"./images/countries/LUX.svg": "4f12",
	"./images/countries/LVA.svg": "471f",
	"./images/countries/MAC.svg": "96c0",
	"./images/countries/MAF.svg": "1757",
	"./images/countries/MAR.svg": "7d17",
	"./images/countries/MCO.svg": "0422",
	"./images/countries/MDA.svg": "e9fd",
	"./images/countries/MDG.svg": "8abe",
	"./images/countries/MDV.svg": "af31",
	"./images/countries/MEX.svg": "e274",
	"./images/countries/MHL.svg": "a5e3",
	"./images/countries/MKD.svg": "f8d2",
	"./images/countries/MLI.svg": "6747",
	"./images/countries/MLT.svg": "b188",
	"./images/countries/MMR.svg": "b72e",
	"./images/countries/MNE.svg": "4344",
	"./images/countries/MNG.svg": "83d2",
	"./images/countries/MNP.svg": "a140",
	"./images/countries/MOZ.svg": "f478",
	"./images/countries/MRT.svg": "c11f",
	"./images/countries/MSR.svg": "8619",
	"./images/countries/MTQ.svg": "59c0",
	"./images/countries/MUS.svg": "d839",
	"./images/countries/MWI.svg": "7225",
	"./images/countries/MYS.svg": "93e9",
	"./images/countries/MYT.svg": "be8c",
	"./images/countries/NAM.svg": "8886",
	"./images/countries/NCL.svg": "33ed",
	"./images/countries/NER.svg": "834a",
	"./images/countries/NFK.svg": "f282",
	"./images/countries/NGA.svg": "35a2",
	"./images/countries/NIC.svg": "82b9",
	"./images/countries/NIU.svg": "66dd",
	"./images/countries/NLD.svg": "ab5a",
	"./images/countries/NOR.svg": "9050",
	"./images/countries/NPL.svg": "1a74",
	"./images/countries/NRU.svg": "f1b6",
	"./images/countries/NZL.svg": "8046",
	"./images/countries/OMN.svg": "f671",
	"./images/countries/PAK.svg": "b8ff",
	"./images/countries/PAN.svg": "1e1d",
	"./images/countries/PCN.svg": "265a",
	"./images/countries/PER.svg": "a1ce",
	"./images/countries/PHL.svg": "46c9",
	"./images/countries/PLW.svg": "2d16",
	"./images/countries/PNG.svg": "eb49",
	"./images/countries/POL.svg": "d445",
	"./images/countries/PRI.svg": "3c6a",
	"./images/countries/PRK.svg": "bf5a",
	"./images/countries/PRT.svg": "0004",
	"./images/countries/PRY.svg": "5fbc",
	"./images/countries/PSE.svg": "e074",
	"./images/countries/PYF.svg": "be1e",
	"./images/countries/QAT.svg": "b74e",
	"./images/countries/REU.svg": "0b96",
	"./images/countries/ROU.svg": "f3f7",
	"./images/countries/RUS.svg": "b39b",
	"./images/countries/RWA.svg": "63a3",
	"./images/countries/SAU.svg": "34e5",
	"./images/countries/SCG.svg": "d23c",
	"./images/countries/SDN.svg": "9b87",
	"./images/countries/SEN.svg": "ff8c",
	"./images/countries/SGP.svg": "f419",
	"./images/countries/SGS.svg": "2c27",
	"./images/countries/SHN.svg": "f23d",
	"./images/countries/SJM.svg": "d164",
	"./images/countries/SLB.svg": "c6a2",
	"./images/countries/SLE.svg": "0752",
	"./images/countries/SLV.svg": "4c35",
	"./images/countries/SMR.svg": "900c",
	"./images/countries/SOM.svg": "485cb",
	"./images/countries/SPM.svg": "ffeb",
	"./images/countries/SRB.svg": "b56a",
	"./images/countries/SSD.svg": "04b8",
	"./images/countries/STP.svg": "1886",
	"./images/countries/SUR.svg": "ae12",
	"./images/countries/SVK.svg": "9901",
	"./images/countries/SVN.svg": "5952",
	"./images/countries/SWE.svg": "d253",
	"./images/countries/SWZ.svg": "2f4d",
	"./images/countries/SXM.svg": "a9d6",
	"./images/countries/SYC.svg": "4568",
	"./images/countries/SYR.svg": "1e81",
	"./images/countries/TCA.svg": "6001",
	"./images/countries/TCD.svg": "1c92",
	"./images/countries/TGO.svg": "39f2",
	"./images/countries/THA.svg": "8c9b",
	"./images/countries/TJK.svg": "c408",
	"./images/countries/TKL.svg": "85e8",
	"./images/countries/TKM.svg": "8341",
	"./images/countries/TLS.svg": "6655",
	"./images/countries/TON.svg": "d034",
	"./images/countries/TTO.svg": "271c",
	"./images/countries/TUN.svg": "5056",
	"./images/countries/TUR.svg": "9973",
	"./images/countries/TUV.svg": "7150",
	"./images/countries/TWN.svg": "932e",
	"./images/countries/TZA.svg": "6843",
	"./images/countries/UGA.svg": "c60f",
	"./images/countries/UKR.svg": "5425",
	"./images/countries/UMI.svg": "60d5",
	"./images/countries/URY.svg": "71b9",
	"./images/countries/USA.svg": "21f5",
	"./images/countries/UZB.svg": "278e",
	"./images/countries/VAT.svg": "a84f",
	"./images/countries/VCT.svg": "d7b2",
	"./images/countries/VEN.svg": "705c",
	"./images/countries/VGB.svg": "674b",
	"./images/countries/VIR.svg": "58b7",
	"./images/countries/VNM.svg": "7e10",
	"./images/countries/VUT.svg": "fd67",
	"./images/countries/WLF.svg": "06c3",
	"./images/countries/WSM.svg": "9589",
	"./images/countries/XKX.svg": "7e26",
	"./images/countries/YEM.svg": "51fa",
	"./images/countries/ZAF.svg": "3f63",
	"./images/countries/ZMB.svg": "b0d5",
	"./images/countries/ZWE.svg": "90fe",
	"./images/countries/unknown.svg": "fded",
	"./images/countries/world.svg": "e30a",
	"./images/logo-polarize.png": "d0f0",
	"./images/players/player-example.png": "46a0",
	"./networks/888.png": "110a",
	"./networks/888_btc.png": "33be",
	"./networks/888_eur.png": "9b83",
	"./networks/888_usd.png": "b252",
	"./networks/aconcagua.png": "341a",
	"./networks/aconcagua_btc.png": "b2c9",
	"./networks/aconcagua_eur.png": "0c0a",
	"./networks/aconcagua_usd.png": "0155",
	"./networks/acr_btc.png": "5a95",
	"./networks/acr_eur.png": "3b1b",
	"./networks/acr_usd.png": "b262",
	"./networks/agribank_btc.png": "0cfa",
	"./networks/agribank_eur.png": "7982",
	"./networks/agribank_usd.png": "fbf9",
	"./networks/betfair.png": "cc15",
	"./networks/betfair_btc.png": "4adf",
	"./networks/betfair_eur.png": "2581",
	"./networks/betfair_usd.png": "650f",
	"./networks/betonline.png": "b76b",
	"./networks/betonline_btc.png": "cb84",
	"./networks/betonline_eur.png": "a18b",
	"./networks/betonline_usd.png": "17ab",
	"./networks/blackchippoker_btc.png": "ccd0",
	"./networks/blackchippoker_eur.png": "4a4b",
	"./networks/blackchippoker_usd.png": "a1d4",
	"./networks/bodog.png": "d4a0",
	"./networks/bodog_btc.png": "98e9",
	"./networks/bodog_eur.png": "43cf",
	"./networks/bodog_usd.png": "91a2",
	"./networks/championpoker_btc.png": "3673",
	"./networks/championpoker_eur.png": "f00e",
	"./networks/championpoker_usd.png": "6a70",
	"./networks/chico.png": "6601",
	"./networks/chico_btc.png": "c3d9",
	"./networks/chico_eur.png": "99be",
	"./networks/chico_usd.png": "d1db",
	"./networks/coinbase_btc.png": "8662",
	"./networks/coinbase_eur.png": "6091",
	"./networks/coinbase_usd.png": "ae53",
	"./networks/cristalpoker.png": "7f89",
	"./networks/cristalpoker_btc.png": "e431",
	"./networks/cristalpoker_eur.png": "8ebf",
	"./networks/cristalpoker_usd.png": "0773",
	"./networks/ecopayz.png": "d59c",
	"./networks/ecopayz_btc.png": "e30f",
	"./networks/ecopayz_eur.png": "e7f6",
	"./networks/ecopayz_usd.png": "d783",
	"./networks/esc_btc.png": "7b1f",
	"./networks/esc_eur.png": "b887",
	"./networks/esc_usd.png": "4637",
	"./networks/gg.png": "0824",
	"./networks/gg_btc.png": "cb4b",
	"./networks/gg_eur.png": "ece9",
	"./networks/gg_usd.png": "4b9c",
	"./networks/ignitioncasino_btc.png": "7eca",
	"./networks/ignitioncasino_eur.png": "921b",
	"./networks/ignitioncasino_usd.png": "ed91",
	"./networks/ipoker.png": "d404",
	"./networks/ipoker_btc.png": "deae",
	"./networks/ipoker_eur.png": "dd5b",
	"./networks/ipoker_usd.png": "8bff",
	"./networks/j88_btc.png": "a85d",
	"./networks/j88_eur.png": "4e8c",
	"./networks/j88_usd.png": "bf6e",
	"./networks/j88poker.png": "4cc7",
	"./networks/live.png": "4b9f",
	"./networks/luxon_eur.png": "8856",
	"./networks/luxon_usd.png": "07c7",
	"./networks/luxon_usdt.png": "0f83",
	"./networks/microgaming.png": "1b2a",
	"./networks/microgaming_btc.png": "4f85",
	"./networks/microgaming_eur.png": "e94d",
	"./networks/microgaming_usd.png": "515e",
	"./networks/millennium_eur.png": "eda4",
	"./networks/muchbetter_btc.png": "730b",
	"./networks/muchbetter_eur.png": "efb0",
	"./networks/muchbetter_usd.png": "78ef",
	"./networks/n26.png": "ae87",
	"./networks/n26_btc.png": "f556",
	"./networks/n26_eur.png": "ff68",
	"./networks/n26_usd.png": "3615",
	"./networks/natural8.png": "3ab5",
	"./networks/natural8_btc.png": "6e97",
	"./networks/natural8_eur.png": "6d92",
	"./networks/natural8_usd.png": "261d",
	"./networks/neteller.png": "bc0e",
	"./networks/neteller_btc.png": "7933",
	"./networks/neteller_eur.png": "28e1",
	"./networks/neteller_usd.png": "7f65",
	"./networks/partypoker.png": "0238",
	"./networks/partypoker_btc.png": "029e",
	"./networks/partypoker_eur.png": "7b90",
	"./networks/partypoker_usd.png": "cf12",
	"./networks/pokerking_btc.png": "dee9",
	"./networks/pokerking_eur.png": "53e9",
	"./networks/pokerking_usd.png": "d9d1",
	"./networks/pokerok.png": "cf5b",
	"./networks/pokerok_btc.png": "9f57",
	"./networks/pokerok_eur.png": "c35d",
	"./networks/pokerok_usd.png": "b594",
	"./networks/pokerstars.png": "64a5",
	"./networks/pokerstars_btc.png": "42d4",
	"./networks/pokerstars_eur.png": "918f",
	"./networks/pokerstars_usd.png": "97b0",
	"./networks/ppipoker_btc.png": "64f5",
	"./networks/ppipoker_eur.png": "a80e",
	"./networks/ppipoker_usd.png": "8209",
	"./networks/pppoker.png": "1f38",
	"./networks/pppoker_btc.png": "edb4",
	"./networks/pppoker_eur.png": "bf73",
	"./networks/pppoker_usd.png": "a082",
	"./networks/revolut_btc.png": "54cf",
	"./networks/revolut_eur.png": "8440",
	"./networks/revolut_usd.png": "c46f",
	"./networks/revolution_btc.png": "c1a9",
	"./networks/revolution_eur.png": "597f",
	"./networks/revolution_usd.png": "937c",
	"./networks/skrill.png": "66d1",
	"./networks/skrill_btc.png": "cbfe",
	"./networks/skrill_eur.png": "4f33",
	"./networks/skrill_usd.png": "1d63",
	"./networks/tiger_btc.png": "9c72",
	"./networks/tiger_eur.png": "7a66",
	"./networks/tiger_usd.png": "9880",
	"./networks/tigergaming.png": "c526",
	"./networks/unibet.png": "e869",
	"./networks/unibet_btc.png": "577b",
	"./networks/unibet_eur.png": "7ee0",
	"./networks/unibet_usd.png": "cfeb",
	"./networks/winamax.png": "d04f",
	"./networks/winamax_btc.png": "2a3d",
	"./networks/winamax_eur.png": "2bd2",
	"./networks/winamax_usd.png": "9b05",
	"./networks/withdraw.png": "8b83",
	"./networks/withdraw_btc.png": "2877b",
	"./networks/withdraw_eur.png": "53a7",
	"./networks/withdraw_lg.png": "9a29",
	"./networks/withdraw_usd.png": "e9c1",
	"./networks/wpn.png": "a9b0",
	"./networks/wpn_btc.png": "0d94",
	"./networks/wpn_eur.png": "96eb",
	"./networks/wpn_usd.png": "64db",
	"./networks/wpt.png": "393b",
	"./networks/wpt_btc.png": "dc26",
	"./networks/wpt_eur.png": "c76b",
	"./networks/wpt_usd.png": "a4a8",
	"./networks/wsop_btc.png": "38c0",
	"./networks/wsop_eur.png": "db7e",
	"./networks/wsop_usd.png": "f6b8",
	"./networks/yapoker_btc.png": "3043",
	"./networks/yapoker_eur.png": "d77a",
	"./networks/yapoker_usd.png": "8a39",
	"./teams/cash.png": "e1d8",
	"./teams/mtt.png": "e5cc",
	"./teams/noteam.png": "bc28",
	"./teams/spins.png": "9b29"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";